// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

//Logo Carousel 
const logoswiper = new Swiper('.logos', {
    // Optional parameters
	modules: [Autoplay, Navigation, Pagination], 
    loop: true,
	slidesPerView: 2,
    freeMode: true,
    autoHeight: true, // Make slides equal height
	breakpoints: {
		1200:{
			slidesPerView: 7,
		},
		992:{
			slidesPerView: 4,
		},
		782:{
			slidesPerView: 2,
		},
	},
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.logos-swiper-button-next',
		prevEl: '.logos-swiper-button-prev',
	},
});


// Before / After Carousel (Disables loop if there is fewer than 6 slides)
const swiperContainer = document.querySelector('.wp-block-lazyblock-before-after-carousel .swiper');
let swiperSlides;
//
if (swiperContainer){
    swiperSlides = swiperContainer.querySelectorAll('.swiper-slide');
}

const swiperConfig = {
    modules: [Autoplay, Navigation, Pagination],
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    breakpoints: {
        991: {
            slidesPerView: 2.5,
        },
    },
    navigation: {
        nextEl: '.before-after-swiper-button-next',
        prevEl: '.before-after-swiper-button-prev',
    },
    // Move one slide at a time
    slideToClickedSlide: true,
    on: {
        init: function () {
            this.update();
        },
    },
};

// Add event listeners for Enter key press on navigation buttons
//const prevButton = document.querySelector('.before-after-swiper-button-prev');
//const nextButton = document.querySelector('.before-after-swiper-button-next');

// Check the number of slides and adjust the config
if (swiperContainer && swiperSlides.length >= 6) {
    swiperConfig.loop = true;
    swiperConfig.loopAdditionalSlides = 5; // Adjust this number as needed
} else {
    swiperConfig.loop = false;
}

const swiperBefore = new Swiper(swiperContainer, swiperConfig);



//Google Reviews Carousel Single
const reviewsswiper = new Swiper('.wp-block-lazyblock-google-reviews .swiper', {
    // Optional parameters
	modules: [Autoplay, Navigation, Pagination],
    loop: true,
	slidesPerView: 1,
    freeMode: true,
	autoHeight: true, // Make slides equal height
	autoplay: {
		delay: 10000,
	},
	// Navigation arrows
	navigation: {
		nextEl: '.google-reviews-swiper-button-next',
		prevEl: '.google-reviews-swiper-button-prev',
	},
});


//Google Reviews Carousel Multiple (4 in a row)
const multireviewsswiper = new Swiper('.wp-block-lazyblock-google-reviews .swiper.reviews-row', {
    // Optional parameters
    modules: [Autoplay, Navigation, Pagination],
    spaceBetween: 30,
    freeMode: true,
    autoHeight: true, // Make slides equal height
    breakpoints: {
        640: {
            slidesPerView: 1,
        },
        768: {
            slidesPerView: 2,
        },
        1024: {
            slidesPerView: 3,
        },
        1200: {
            slidesPerView: 4,
        },
    },
    // Navigation arrows
    navigation: {
        nextEl: '.google-reviews-swiper-button-next',
        prevEl: '.google-reviews-swiper-button-prev',
    },
});

//
// Trigger class in header to resize and animate
//
// Throttle function to limit how often resizeHeader is called
function throttle(func, limit = 100) {
    let lastFunc;
    let lastRan;
    return function () {
        const context = this;
        const args = arguments;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(function () {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
}

// State to lock the small-header class once added
let smallHeaderAdded = false;

// Function to resize the header
function resizeHeader() {
    const header = document.querySelector('.sticky-top');
    
    // Add class when scrolling down beyond the threshold (e.g., 20px)
    if (window.scrollY > 20 && !smallHeaderAdded) {
        header.classList.add('small-header');
        smallHeaderAdded = true; // Lock the state to prevent flickering
    }
    // Remove class only when scrolled back up near the top (e.g., less than 5px)
    else if (window.scrollY < 5 && smallHeaderAdded) {
        header.classList.remove('small-header');
        smallHeaderAdded = false; // Unlock the state when near the top
    }
}

// Attach the throttled version of resizeHeader to the scroll event
window.addEventListener('scroll', throttle(resizeHeader, 100)); // Adjust the 100ms as needed



//
// Smooth Scrolling for Anchor Links
//
jQuery(document).ready(function($) {
    $('a[href^="#anchor-"]').on('click', function(e){
        e.preventDefault(); // Prevent default behavior of anchor click

        var link = $(this).attr('href'); // Get the target link
        var linkOffset = $(link).offset().top; // Get the position of the target

        // Adjusting for the sticky header height
        var headerHeight = $('.sticky-top').outerHeight(); 

        // Smooth scroll with header height offset
        $('html, body').animate({
            scrollTop: linkOffset - headerHeight // Offset by the header height
        }, 'fast');
    });
});

//
// Back to Top Button
//
var mybutton = document.getElementById("btn-back-to-top");

// When the user scrolls down 20px from the top of the document, show the button
window.onscroll = function () {
    scrollFunction();
};

function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
        mybutton.style.display = "block";
    } else {
        mybutton.style.display = "none";
    }
}

// When the user clicks on the button, scroll to the top of the document
mybutton.addEventListener("click", backToTop);

function backToTop() {
    jQuery("html, body").animate({ scrollTop: 0 }, "slow");
}


// Animation effect library for npm splitting and scroll-out
import ScrollOut from "scroll-out";

// Fade In Left Effect Animation 
ScrollOut({
    targets:'.image-background.left img,' + 
    '.image-background.right .wp-block-cover__inner-container,' + 
    '.image-text .wp-block-column:first-child,' + 
    '.image-intro .wp-block-cover__inner-container .wp-block-column:first-child,' +
    '.benefits-section .wp-block-column:first-child .wp-block-media-text',
    onShown: function(el) {
        // Only trigger the animation once
        if (!el.classList.contains('animated-once')) {
            // Add the animate.css classes
            el.classList.add('animate__animated', 'animate__fadeInLeft');
            // Add a custom class to mark it as animated
            el.classList.add('animated-once');
        }
    },
    once: true // Ensures ScrollOut only triggers the animation once
});

// Fade In Right Effect Animation 
ScrollOut({
    targets:'.image-background.left .wp-block-cover__inner-container,' +
    '.image-background.right img, ' + 
    '.image-text .wp-block-column:last-child, ' + 
    '.image-intro .wp-block-cover__inner-container .wp-block-column:last-child, ' +
    '.benefits-section .wp-block-column:last-child .wp-block-media-text',
    onShown: function(el) {
        // Only trigger the animation once
           if (!el.classList.contains('animated-once')) {
            // Add the animate.css classes
            el.classList.add('animate__animated', 'animate__fadeInRight');
            // Add a custom class to mark it as animated
            el.classList.add('animated-once');
        }
   },
   once: true // Ensures ScrollOut only triggers the animation once
});

document.addEventListener('DOMContentLoaded', function() {
    // Select cover blocks with the class 'no-srcset-cover'
    const coverBlocks = document.querySelectorAll('.wp-block-cover.no-srcset-cover');

    coverBlocks.forEach(block => {
        const images = block.querySelectorAll('img');
        images.forEach(img => {
            // Remove srcset and sizes attributes
            img.removeAttribute('srcset');
            img.removeAttribute('sizes');
        });
    });
});
